import { IEmployee } from '../store/employees/types'
import { Roles } from './consts'

export const checkFio = (user: IEmployee) => {
  const end = user.approved ? '' : ' (x)'
  return user.role === Roles.CHIEF ? `${user.fio}, керівник${end}` : `${user.fio}${end}`
}
